import { useQuery } from '@apollo/client';

import { ScheduledTransferDetailsDocument } from './scheduledTransferDetails.gql';

const useScheduledTransferDetails = (scheduledBankTransferId: string) => {
  const { data, error, loading, networkStatus, refetch } = useQuery(
    ScheduledTransferDetailsDocument,
    {
      variables: { scheduledBankTransferId },
    },
  );

  return {
    error,
    loading,
    networkStatus,
    refetch,
    scheduledTransfer: data?.viewer.scheduledBankTransfer,
  };
};

export default useScheduledTransferDetails;
